define([
  "jquery",
  "knockout"],
function($, ko) {

  ko.bindingHandlers.blurHandle = {

    init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {

      var data = valueAccessor().data;
      var onBlur = valueAccessor().blur;
      var doProcess = valueAccessor().process;

      var pendingTimeout = null;

      function blurHandler() {
        // Defer to the next tick so Knockout's value binding (which fires on
        // "change", which comes after "blur") has already updated the observable
        // before we call validate(). Without this, re-validation after editing a
        // field sees the pre-edit value and errors never clear.
        if (pendingTimeout !== null) {
          clearTimeout(pendingTimeout);
          pendingTimeout = null;
        }
        pendingTimeout = setTimeout(function() {
          pendingTimeout = null;
          if (typeof onBlur !== "undefined") {
            onBlur(data);
          }
          if (typeof doProcess !== "undefined") {
            doProcess(data);
          }
        }, 0);
      }

      $(element).blur(blurHandler);

      ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
        if (pendingTimeout !== null) {
          clearTimeout(pendingTimeout);
          pendingTimeout = null;
        }
        $(element).off("blur", blurHandler);
      });

    }

  }

});
